import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { licenceStatusSelector } from '../selectors/wizardSelectors';
import Licence from '../components/Licence/Licence';

const mapStateToProps = createStructuredSelector({ licenceStatus: licenceStatusSelector });

export default connect(mapStateToProps, null)(Licence);
